// Widget Scripts
import ticketButton from './js/widgets/ticketButton.js';
import cardWidgetVideo from './js/widgets/cardWidgetVideo.js';
import cardWidgetOne from './js/widgets/cardWidgetOne.js';
import cardWidgetTwo from './js/widgets/cardWidgetTwo.js';
import cardWidgetEvents from './js/widgets/cardWidgetEvents.js';
import cardWidgetFour from './js/widgets/cardWidgetFour.js';
import cardWidgetFive from './js/widgets/cardWidgetFive.js';
import cardWidgetSix from './js/widgets/cardWidgetSix.js';
import cssSponsors from './js/widgets/cssSponsors.js'
import cardWidgetSeven from './js/widgets/cardWidgetSeven.js';
import customPopUp from './js/widgets/customPopUp.js';

// Custom Theme Scripts
import './js/localjs.js';
import './js/siteInfoBanner.js';
// Aos Library
import AOS from 'aos';
import 'aos/dist/aos.css';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    customPopUp();
    cardWidgetVideo();
    cardWidgetOne();
    cardWidgetTwo();
    cardWidgetEvents();
    cardWidgetFour();
    cardWidgetFive();

  });

  $(window).load(function () {

    setTimeout(() => {
      AOS.init({
        anchorPlacement: 'bottom-bottom',
        animatedClassName: 'aos-animate',
        initClassName: 'aos-init',
      });
    }, 2000)
  })
}

$(document).ready(function () {
  ticketButton();
  cardWidgetSix();
  cssSponsors();
  cardWidgetSeven();
})